<template>
  <div class="d-flex host" style="width:100%">
    <div :style="styles" v-for="item in tree" :key="item.name" class="vm-nav-item">
      <template v-if="item.children">
        <Menu v-if="!showSide" class="vm-navbar-menu">
          <template #activator="{ on }">
            <button
              type="button"
              @click="on"
              class="vm-navbar-button vm-dropdown-button"
            >
              {{ item.title }}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
                width="24"
                fill="white"
                class="svg_drop"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M7 10l5 5 5-5z" />
              </svg>
            </button>
          </template>
          <template #default>
            <div class="vm-list">
              <router-link
                v-for="subitem in item.children"
                :key="subitem.name"
                :to="{ name: subitem.name }"
                class="vm-button"
              >
                {{ subitem.title }}
              </router-link>
            </div>
          </template>
        </Menu>
      </template>
      <template v-else>
        <template v-if="!showSide" >
          <template v-if="$store.state.navigation.site">
            <router-link :to="{ name: item.name, params: {clinicName: item.clinicName ? item.clinicName : undefined} }" class="vm-navbar-button">
              {{ item.title }}
            </router-link>
          </template>
          <template v-else>
            <router-link :to="{ name: item.name, path: item.path ? item.path: undefined, params: {clinicName: item.clinicName ? item.clinicName : undefined} }" class="vm-navbar-button">
              {{ item.title }}
            </router-link>
          </template>
        </template>
      </template>
    </div>
    <!--div class="vm-nav-item">
      <a href="tel:+79829966736" class="vm-navbar-button vm-navbar-phone-button">8 982 996 67 36</a>
    </div-->
    <div v-if="!$store.state.navigation.site" :style="styles" class="vm-nav-item" id="navClinics" style="margin-left:auto; cursor:pointer">
      <a @click="openClinics" class="vm-navbar-button vm-navbar-phone-button">{{current_clinicName}}</a>
    </div>
    <DropList v-if="clinics" @clickOutside="clinics= false" :activeClinic="current_clinicName" :position="clinicsPosition" @push="chooseClinic" />
  <!--a id="specialButton" href="#"><img src="https://lidrekon.ru/images/special.png" alt="ВЕРСИЯ ДЛЯ СЛАБОВИДЯЩИХ" title="ВЕРСИЯ ДЛЯ СЛАБОВИДЯЩИХ" /></a-->
  </div>
</template>

<script>
import Menu from '@app/components/uikit/Menu';
import DropList from '@app/components/uikit/DropList';

export default {
  components: {
    Menu, DropList
  },
  props: {
    tree: Array,
    primaryColor: String,
    secondaryColor: String,
    showSide: Boolean
  },
  data() {
    return {
      clinics: false,
      clinicsPosition: 0,
      current_clinicName: 'Выберите клинику',
      activeItem: ''
    };
  },
  computed: {
    styles() {
      return {
        '--primary-color': this.primaryColor,
        '--secondary-color': this.secondaryColor
      };
    }
  },
  mounted() {
    console.log({
      primaryColor: this.primaryColor,
      secondaryColor: this.secondaryColor,
    });
    if(this.$store.state.clinic.id) {
      this.current_clinicName = this.$store.state.clinic.organization.form.title;
    }
  },
  methods: {
    openClinics() {
      this.clinicsPosition = document.getElementById('navClinics').offsetLeft;
      this.clinics = !this.clinics;
    },
    chooseClinic(item) {
      this.clinics = !this.clinics;
      this.$router.push({name: 'clinic.public', params: {clinicName: item.slug ? item.slug : item.id}});
      this.current_clinicName = item.title;
    },
    refresh() {
      this.current_clinicName = this.$store.state.clinic.organization.form.title;
    }
  },
  watch: {
    '$store.state.clinic.organization.form.title' : 'refresh'
  }
};
</script>

<style lang="scss" scoped>
.activeItem {
  pointer-events: none;
  background-color: white !important;
  color: #a32cdf !important;
}
.host {
  display: flex;
  align-self: stretch;
}
.vm-navbar-menu {
  height: 100%;
}
.vm-list {
  margin: 0.5rem;
}
.vm-dropdown-button svg {
  fill: white;
}
.vm-list a.vm-button {
  color: #262626;
  display: block;
  padding: 0.5rem 1rem;
  white-space: nowrap;
  text-decoration: none;
  border-radius: 3px;
}
.vm-list a.vm-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.vm-navbar-button {
  border: 0;
  padding: 1.2rem 0.5rem;
  text-transform: uppercase;
  margin-left: 5px;
  color: white;
  background-color: transparent;
  display: flex;
  height: 100%;
  align-items: center;
}
button.vm-navbar-button {
  outline: none;
  display: flex;
  padding-right: 0;
}
a.vm-navbar-button {
  text-decoration: none;
}
.vm-navbar-button:hover {
  background-color: var(--secondary-color);
  color: var(--primary-color);
}
.vm-navbar-button:hover .svg_drop {
  fill: var(--primary-color);
}
</style>
